import { buildApiUrl, API_ENDPOINTS, apiRequest } from '../config/api.js'

export const payrollApi = {
  // Get payroll data for a specific user
  async getPayrollData(userId) {
    try {
      const url = buildApiUrl(API_ENDPOINTS.PAYROLL.BY_USER(userId))
      const response = await apiRequest(url)
      return response
    } catch (error) {
      console.error('Failed to load payroll data:', error)
      throw new Error('Unable to load payroll data. Please check your connection and try again.')
    }
  }
}
